import axios from "axios";
import { API_BASE_URL } from "@/config/config";

const PublicApi = () => axios.create({
    baseURL: API_BASE_URL,
    headers: {
        Accept: "application/json"
    },
    timeout: 30000
});

export default PublicApi;
